import React, { useContext } from 'react';
import { ApLoaderDefault } from '@alixpartners/ui-components';
import { CardValue, KpiCard, Wrapper } from './KpiList.styles';
import { formatNumber, formatSpendWithDecimalAndSymbol } from 'utils/number';
import { SettingsContext } from 'contexts/SettingsContext';

const KpiElement = ({ data, isLoading, isLeft }) => {
	return (
		<KpiCard isLeft={isLeft}>
			{isLoading ? (
				<ApLoaderDefault />
			) : (
				<Wrapper>
					<div>
						<CardValue>{data.value1}</CardValue>
					</div>
					<div>
						<CardValue>{data.value2}</CardValue>
					</div>
				</Wrapper>
			)}
		</KpiCard>
	);
};

const KpiList = ({
	vendorCountData,
	vendorSpendData,
	isVendorSpendLoading,
	isVendorCountLoading,
}) => {
	const { hideDecimals } = useContext(SettingsContext);
	const getTotal = data => {
		return data
			.map(vendor => vendor.value)
			.reduce((acc, curr) => acc + curr, 0);
	};

	return (
		<>
			<KpiElement
				data={{
					value1: 'Vendor Count',
					value2: formatNumber(getTotal(vendorCountData)),
				}}
				isLoading={isVendorCountLoading}
				isLeft={true}
			/>
			<KpiElement
				data={{
					value1: 'Total Spend',
					value2: formatSpendWithDecimalAndSymbol(
						getTotal(vendorSpendData),
						'$',
						hideDecimals,
						2
					).toUpperCase(),
				}}
				isLoading={isVendorSpendLoading}
				isLeft={false}
			/>
		</>
	);
};

export default KpiList;
